import { createAction, handleActions } from 'redux-actions'
import _ from 'lodash'
import { QuizType } from '../../commons/EditorStatus'
import dayjs from '../../commons/plugins/dayjs'
import { LOCATION_CHANGE } from 'react-router-redux'
import { ranking } from '../components/organisms/PresentationControllerStatus/PresentationControllerStatus.css'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'editor'

export const FINISH_LOADING = createAction(`${BASE_ACTION_NAME}/finish_loading`)

export const CHANGE_ANSWER_CHOICE = createAction(`${BASE_ACTION_NAME}/change_answer_choice`)
export const CHANGE_PROJECT_TITLE = createAction(`${BASE_ACTION_NAME}/change_project_title`)
export const CHANGE_RANKING_CONFIG = createAction(`${BASE_ACTION_NAME}/change_ranking_config`)
export const CHANGE_RANKING_CONFIG_SUCCESS = createAction(`${BASE_ACTION_NAME}/change_ranking_config/success`)
export const CHANGE_EVENT_TITLE = createAction(`${BASE_ACTION_NAME}/change_event_title`)
export const CHANGE_QUESTION_TITLE = createAction(`${BASE_ACTION_NAME}/change_question_title`)
export const CHANGE_TIME_LIMIT = createAction(`${BASE_ACTION_NAME}/change_time_limit`)
export const CHANGE_CHOICE_TITLE = createAction(`${BASE_ACTION_NAME}/change_choice_title`)
export const SEND_EDITOR_INDEX = createAction(`${BASE_ACTION_NAME}/send_editor_index`)
export const SELECT_INDEX_TYPE = createAction(`${BASE_ACTION_NAME}/send_editor_index_type`)
export const CHANGE_QUESTION_INDEX = createAction(`${BASE_ACTION_NAME}/change_question_index`)

export const SHOW_QUIZ_START_MODAL = createAction(`${BASE_ACTION_NAME}/show_quiz_start_modal`)
export const HIDE_QUIZ_START_MODAL = createAction(`${BASE_ACTION_NAME}/hide_quiz_start_modal`)

export const SHOW_IMAGE_UPLOAD_MODAL = createAction(`${BASE_ACTION_NAME}/show_image_upload_modal`)
export const HIDE_IMAGE_UPLOAD_MODAL = createAction(`${BASE_ACTION_NAME}/hide_image_upload_modal`)

export const SHOW_EDITOR_HEADER_MENU = createAction(`${BASE_ACTION_NAME}/show_editor_header_menu`)
export const HIDE_EDITOR_HEADER_MENU = createAction(`${BASE_ACTION_NAME}/hide_editor_header_menu`)

export const FETCH_PROJECT = createAction(`${BASE_ACTION_NAME}/fetch_project`)
export const FETCH_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/index/success`)
export const FETCH_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/index/failure`)

export const UPDATE_PROJECT_STARTED = createAction(`${BASE_ACTION_NAME}/update_project_started`)
export const UPDATE_PROJECT_STARTED_SUCCESS = createAction(`${BASE_ACTION_NAME}/update_project_started/success`)
export const UPDATE_PROJECT_STARTED_FAILURE = createAction(`${BASE_ACTION_NAME}/update_project_started/failure`)

export const RESET_PROJECT = createAction(`${BASE_ACTION_NAME}/reset_project`)
export const RESET_PROJECT_SUCCESS = createAction(`${BASE_ACTION_NAME}/reset_project/success`)
export const RESET_PROJECT_FAILURE = createAction(`${BASE_ACTION_NAME}/reset_project/failure`)

export const UPDATE_QUESTION_TYPE = createAction(`${BASE_ACTION_NAME}/update_question_type`)
export const UPDATE_QUESTION_TYPE_SUCCESS = createAction(`${BASE_ACTION_NAME}/update_question_type/success`)
export const UPDATE_QUESTION_TYPE_FAILURE = createAction(`${BASE_ACTION_NAME}/update_question_type/failure`)

export const UPDATE_CHOICE_IMAGE = createAction(`${BASE_ACTION_NAME}/update_choice_image`)
export const UPDATE_CHOICE_IMAGE_SUCCESS = createAction(`${BASE_ACTION_NAME}/update_choice_image/success`)
export const UPDATE_CHOICE_IMAGE_FAILURE = createAction(`${BASE_ACTION_NAME}/update_choice_image/failure`)

export const CONFIRM_DELETE_QUESTION = createAction(`${BASE_ACTION_NAME}/confirm_delete_question`)
export const HIDE_CONFIRM_DELETE_QUESTION = createAction(`${BASE_ACTION_NAME}/hide_confirm_delete_question`)

export const DELETE_CHOICE_IMAGE = createAction(`${BASE_ACTION_NAME}/delete_choice_image/`)
export const DELETE_CHOICE_IMAGE_SUCCESS = createAction(`${BASE_ACTION_NAME}/delete_choice_image/success`)
export const DELETE_CHOICE_IMAGE_FAILURE = createAction(`${BASE_ACTION_NAME}/delete_choice_image/failure`)

export const CREATE_QUESTION = createAction(`${BASE_ACTION_NAME}/create_question`)
export const CREATE_QUESTION_SUCCESS = createAction(`${BASE_ACTION_NAME}/create_question/success`)
export const CREATE_QUESTION_FAILURE = createAction(`${BASE_ACTION_NAME}/create_question/failure`)

export const DELETE_QUESTION = createAction(`${BASE_ACTION_NAME}/delete_question`)
export const DELETE_QUESTION_SUCCESS = createAction(`${BASE_ACTION_NAME}/delete_question/success`)
export const DELETE_QUESTION_FAILURE = createAction(`${BASE_ACTION_NAME}/delete_question/failure`)

export const UPDATE_EVENT_IMAGE = createAction(`${BASE_ACTION_NAME}/update_event_image/`)
export const UPDATE_EVENT_IMAGE_SUCCESS = createAction(`${BASE_ACTION_NAME}/update_event_image/success`)
export const UPDATE_EVENT_IMAGE_FAILURE = createAction(`${BASE_ACTION_NAME}/update_event_image/failure`)

export const UPDATE_ALL_QUESTIONS = createAction(`${BASE_ACTION_NAME}/update_all_questions`)
export const UPDATE_ALL_QUESTIONS_SUCCESS = createAction(`${BASE_ACTION_NAME}/update_all_questions/success`)
export const UPDATE_ALL_QUESTIONS_FAILURE = createAction(`${BASE_ACTION_NAME}/update_all_questions/failure`)

export const LOG_OUT = createAction(`${BASE_ACTION_NAME}/log_out`)
export const LOG_OUT_SUCCESS = createAction(`${BASE_ACTION_NAME}/log_out/success`)
export const LOG_OUT_FAILURE = createAction(`${BASE_ACTION_NAME}/log_out/failure`)

export const GET_IS_FETCHABLE_RANKING_DATA = createAction(`${BASE_ACTION_NAME}/get_is_fetchable_ranking_data`)
export const GET_IS_FETCHABLE_RANKING_DATA_SUCCESS = createAction(
  `${BASE_ACTION_NAME}/get_is_fetchable_ranking_data/success`
)
export const GET_IS_FETCHABLE_RANKING_DATA_FAILURE = createAction(
  `${BASE_ACTION_NAME}/get_is_fetchable_ranking_data/failure`
)

export const GET_RANKING_DATA = createAction(`${BASE_ACTION_NAME}/get_ranking_data`)
export const GET_RANKING_DATA_SUCCESS = createAction(`${BASE_ACTION_NAME}/get_ranking_data/success`)
export const GET_RANKING_DATA_FAILURE = createAction(`${BASE_ACTION_NAME}/get_ranking_data/failure`)

/////////////////
//// Reducer ////
/////////////////
const initialState = {
  isQuizStartModalShow: false,
  isImageUploadModalShow: false,
  isEditorHeaderMenuShow: false,
  imageUploadTargetIndex: 0,
  canIntervalUpdate: false,
  currentEditIndex: 0,
  editorIndex: 0,
  quizType: QuizType.FIRSTPAGE.value,
  project: null,
  isLoading: false,
  lastUpdatedAt: null,
  eventImageErrorMessage: null,
  choiceImageErrorMessage: null,
  errorMessage: null,
  deleteConfirmQuestionInfo: {
    data: null,
    isShowModal: false
  },
  isFetchableRankingData: false
}

const setProjects = (state, payload) => {
  let newProject = payload
  newProject.updated_at = dayjs(payload.updated_at)
  // 問題タイプを変更した際に情報が消えてしまうので、その情報を残すためにquestionsStoreを用意する
  newProject.questionsStore = {}
  // 現在のquestionをquestionsStoreに生やす
  newProject.questions.forEach((question, index) => {
    const questionStoreKey = `questions_${index}_${question.question_type}`
    newProject.questionsStore[questionStoreKey] = question
    // 作った時期によってはindexが振られていないため連番で振り直す
    question.index = index
  })
  return newProject
}

const setQuestions = (state, payload, key) => {
  let newQuestions = _.cloneDeep(state.project.questions)
  newQuestions[state.currentEditIndex][key] = payload
  return newQuestions
}

const cloneNewQuestions = (state, question) => {
  let newQuestions = _.cloneDeep(state.project.questions)
  const questionsStore = _.cloneDeep(state.project.questionsStore)
  const newQuestionType = question['question_type']
  const storeQuestionKey = `questions_${state.currentEditIndex}_${newQuestionType}`
  // 保存していた選択肢があればそれを採用する
  if (!questionsStore[storeQuestionKey]) {
    newQuestions[state.currentEditIndex] = question
    return newQuestions
  }
  const prevQuestion = questionsStore[storeQuestionKey]
  const prevChoices = prevQuestion['choices']
  const prevAnswerChoiceId = prevQuestion['answer_choice_id']
  // 過去保存していたquestionで更新
  newQuestions[state.currentEditIndex] = prevQuestion
  // answer_choice_idのindexを以前の選択肢のidから得る
  const prevAnswerIndex =
    prevAnswerChoiceId != null ? prevChoices.findIndex(choice => choice.id === prevAnswerChoiceId) : null
  // 選択肢idを更新
  question['choices'].forEach((newChoice, index) => {
    newQuestions[state.currentEditIndex]['choices'][index]['id'] = newChoice['id']
  })
  // questionのidを更新_
  newQuestions[state.currentEditIndex]['id'] = question['id']
  // answer_choice_idを更新
  newQuestions[state.currentEditIndex]['answer_choice_id'] =
    prevAnswerIndex != null ? question.choices[prevAnswerIndex].id : null
  return newQuestions
}

const setQuestionChoices = (state, payload, idx, key) => {
  let newQuestions = _.cloneDeep(state.project.questions)
  let newChoices = _.cloneDeep(state.project.questions[state.currentEditIndex]['choices'])
  newChoices[idx][key] = payload
  newQuestions[state.currentEditIndex]['choices'] = newChoices
  return newQuestions
}

const setQuestionsStore = (state, currentEditIndex) => {
  let newQuestionsTemp = _.cloneDeep(state.project.questionsStore)
  const newQuestions = _.cloneDeep(state.project.questions[currentEditIndex])
  const questionType = newQuestions['question_type']
  const questionTempKey = `questions_${currentEditIndex}_${questionType}`
  newQuestionsTemp[questionTempKey] = newQuestions
  return newQuestionsTemp
}

const setImageToChoices = (state, payload) => {
  let newQuestions = _.cloneDeep(state.project.questions)
  let newChoices = _.cloneDeep(state.project.questions[state.currentEditIndex].choices)
  newChoices.forEach((value, index) => {
    if (payload.data.id === value.id) {
      newChoices[index].image = payload.data.image
    }
  })
  newQuestions[state.currentEditIndex]['choices'] = newChoices
  return newQuestions
}

const deleteImageToChoices = (state, payload) => {
  let newQuestions = _.cloneDeep(state.project.questions)
  let newChoices = _.cloneDeep(state.project.questions[state.currentEditIndex].choices)
  newChoices[payload.targetKey].image = null
  newQuestions[state.currentEditIndex]['choices'] = newChoices
  return newQuestions
}

export default handleActions(
  {
    [FINISH_LOADING]: state => ({
      ...state,
      isLoading: false
    }),
    [SEND_EDITOR_INDEX]: (state, action) => ({
      ...state,
      editorIndex: action.payload
    }),
    [SELECT_INDEX_TYPE]: (state, action) => ({
      ...state,
      currentEditIndex: action.payload.index,
      quizType: action.payload.type
    }),
    [SHOW_QUIZ_START_MODAL]: state => ({
      ...state,
      isQuizStartModalShow: true
    }),
    [HIDE_QUIZ_START_MODAL]: state => ({
      ...state,
      isQuizStartModalShow: false
    }),
    [SHOW_IMAGE_UPLOAD_MODAL]: (state, action) => ({
      ...state,
      isImageUploadModalShow: true,
      imageUploadTargetIndex: action.payload
    }),
    [HIDE_IMAGE_UPLOAD_MODAL]: state => ({
      ...state,
      isImageUploadModalShow: false,
      imageUploadTargetIndex: 0
    }),
    [SHOW_EDITOR_HEADER_MENU]: state => ({
      ...state,
      isEditorHeaderMenuShow: true
    }),
    [HIDE_EDITOR_HEADER_MENU]: state => ({
      ...state,
      isEditorHeaderMenuShow: false
    }),
    [FETCH_PROJECT_SUCCESS]: (state, action) => ({
      ...state,
      project: setProjects(state, action.payload.data)
    }),
    [FETCH_PROJECT_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload
    }),
    [RESET_PROJECT]: (state, { payload }) => ({
      ...state,
      errorMessage: payload,
      isLoading: true
    }),
    [RESET_PROJECT_SUCCESS]: state => ({
      ...state,
      isLoading: false
    }),
    [RESET_PROJECT_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload,
      isLoading: false
    }),
    [UPDATE_PROJECT_STARTED_SUCCESS]: (state, action) => ({
      ...state,
      project: {
        ...state.project,
        is_started: action.payload
      }
    }),
    [UPDATE_PROJECT_STARTED_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload
    }),
    [UPDATE_QUESTION_TYPE]: state => ({
      ...state,
      canIntervalUpdate: false,
      isLoading: true
    }),
    [UPDATE_QUESTION_TYPE_FAILURE]: (state, { payload }) => ({
      ...state,
      canIntervalUpdate: true,
      isLoading: false,
      errorMessage: payload
    }),
    [UPDATE_QUESTION_TYPE_SUCCESS]: (state, { payload }) => ({
      ...state,
      canIntervalUpdate: true,
      isLoading: false,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        questions: cloneNewQuestions(state, payload.data)
      }
    }),
    [CHANGE_QUESTION_TITLE]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        questions: setQuestions(state, action.payload.targetTitle, 'title')
      }
    }),
    [CHANGE_TIME_LIMIT]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      project: {
        ...state.project,
        updated_at: dayjs(),
        questions: setQuestions(state, Number(action.payload), 'limit_time')
      }
    }),
    [CHANGE_CHOICE_TITLE]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        questions: setQuestionChoices(state, action.payload.targetTitle, action.payload.targetKey, 'title')
      }
    }),
    [CHANGE_QUESTION_INDEX]: (state, { payload }) => {
      // 順番を並び替えた後にindexを振り直す
      const cloneQuestions = _.cloneDeep(state.project.questions)
      const { newIndex, oldIndex } = payload
      const [dragQuestion] = cloneQuestions.splice(oldIndex, 1)
      cloneQuestions.splice(newIndex, 0, dragQuestion)
      cloneQuestions.forEach((question, index) => {
        question.index = index
      })

      return {
        ...state,
        canIntervalUpdate: true,
        lastUpdatedAt: dayjs(),
        currentEditIndex: newIndex,
        project: {
          ...state.project,
          questions: cloneQuestions
        }
      }
    },
    [UPDATE_CHOICE_IMAGE]: state => ({
      ...state,
      choiceImageErrorMessage: null,
      canIntervalUpdate: false,
      isLoading: true
    }),
    [UPDATE_CHOICE_IMAGE_FAILURE]: (state, { payload }) => ({
      ...state,
      choiceImageErrorMessage: payload,
      canIntervalUpdate: true,
      isLoading: false
    }),
    [UPDATE_CHOICE_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      choiceImageErrorMessage: null,
      isImageUploadModalShow: false,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      isLoading: false,
      project: {
        ...state.project,
        questions: setImageToChoices(state, action.payload)
      }
    }),

    [DELETE_CHOICE_IMAGE]: state => ({
      ...state,
      canIntervalUpdate: false,
      isLoading: true
    }),
    [DELETE_CHOICE_IMAGE_FAILURE]: state => ({
      ...state,
      canIntervalUpdate: true,
      isLoading: false
    }),
    [DELETE_CHOICE_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      isImageUploadModalShow: false,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      isLoading: false,
      project: {
        ...state.project,
        questions: deleteImageToChoices(state, action.payload)
      }
    }),
    [CHANGE_ANSWER_CHOICE]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        questions: setQuestions(
          state,
          state.project.questions[state.currentEditIndex].choices[Number(action.payload)].id,
          'answer_choice_id'
        )
      }
    }),
    [CREATE_QUESTION]: state => ({
      ...state,
      isLoading: true
    }),

    [CREATE_QUESTION_SUCCESS]: (state, action) => {
      const newQuestions = _.cloneDeep(state.project.questions)
      newQuestions.push(action.payload.data)
      return {
        ...state,
        lastUpdatedAt: dayjs(),
        isLoading: false,
        currentEditIndex: newQuestions.length - 1,
        editorIndex: 0,
        quizType: QuizType.QUESTION.value,
        project: {
          ...state.project,
          questions: newQuestions
        }
      }
    },

    [CREATE_QUESTION_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      errorMessage: payload
    }),

    [CONFIRM_DELETE_QUESTION]: (state, { payload }) => ({
      ...state,
      deleteConfirmQuestionInfo: {
        data: payload,
        isShowModal: true
      }
    }),

    [HIDE_CONFIRM_DELETE_QUESTION]: state => ({
      ...state,
      deleteConfirmQuestionInfo: {
        data: null,
        isShowModal: false
      }
    }),

    [DELETE_QUESTION]: state => ({
      ...state,
      isLoading: true
    }),

    [DELETE_QUESTION_SUCCESS]: (state, action) => {
      const newQuestions = state.project.questions.filter(question => question.id !== action.payload.questionId)

      // 削除でindexがずれるので補正
      newQuestions.forEach((question, index) => {
        question.index = index
      })

      const prevIndex = state.currentEditIndex
      const maxIndex = newQuestions.length - 1
      return {
        ...state,
        lastUpdatedAt: dayjs(),
        isLoading: false,
        canIntervalUpdate: true,
        currentEditIndex: prevIndex > maxIndex ? maxIndex : prevIndex,
        project: {
          ...state.project,
          questions: newQuestions
        },
        deleteConfirmQuestionInfo: {
          data: null,
          isShowModal: false
        }
      }
    },

    [DELETE_QUESTION_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      errorMessage: payload,
      deleteConfirmQuestionInfo: {
        data: null,
        isShowModal: false
      }
    }),

    [CHANGE_EVENT_TITLE]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        presentation_title: action.payload.targetTitle
      }
    }),
    [CHANGE_PROJECT_TITLE]: (state, action) => ({
      ...state,
      canIntervalUpdate: true,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        project_title: action.payload.targetTitle
      }
    }),
    [UPDATE_EVENT_IMAGE]: state => ({
      ...state,
      eventImageErrorMessage: null,
      canIntervalUpdate: false,
      isLoading: true,
      project: {
        ...state.project
      }
    }),
    [UPDATE_EVENT_IMAGE_FAILURE]: (state, error) => ({
      ...state,
      eventImageErrorMessage: error.payload.message,
      canIntervalUpdate: true,
      isLoading: false
    }),
    [UPDATE_EVENT_IMAGE_SUCCESS]: (state, action) => ({
      ...state,
      eventImageErrorMessage: null,
      canIntervalUpdate: true,
      isLoading: false,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        image: action.payload.data.image
      }
    }),
    [CHANGE_RANKING_CONFIG]: state => {
      return {
        ...state,
        isLoading: true
      }
    },
    [CHANGE_RANKING_CONFIG_SUCCESS]: (state, action) => {
      return {
        ...state,
        canIntervalUpdate: true,
        isLoading: false,
        lastUpdatedAt: dayjs(),
        project: {
          ...state.project,
          ranking_count: action.payload
        }
      }
    },
    [UPDATE_ALL_QUESTIONS_SUCCESS]: state => ({
      ...state,
      canIntervalUpdate: false,
      lastUpdatedAt: dayjs(),
      project: {
        ...state.project,
        questionsStore: setQuestionsStore(state, state.currentEditIndex)
      }
    }),
    [LOCATION_CHANGE]: state => ({
      ...state,
      isEditorHeaderMenuShow: false,
      isQuizStartModalShow: false,
      deleteConfirmQuestionInfo: {
        data: null,
        isShowModal: false
      }
    }),
    [GET_IS_FETCHABLE_RANKING_DATA]: state => ({
      ...state
    }),
    [GET_IS_FETCHABLE_RANKING_DATA_SUCCESS]: (state, action) => ({
      ...state,
      isFetchableRankingData: action.payload.is_enable_ranking_output
    }),
    [GET_IS_FETCHABLE_RANKING_DATA_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload
    }),
    [GET_RANKING_DATA]: state => ({
      ...state,
      isLoading: true
    }),
    [GET_RANKING_DATA_SUCCESS]: state => ({
      ...state,
      isLoading: false
    }),
    [GET_RANKING_DATA_FAILURE]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      errorMessage: payload
    })
  },
  initialState
)
